import { Box, Grid } from '@mui/material';
import ContentCard from '../../components/ContentCard/ContentCard';
import ContentList from '../../components/ContentList';
import { categories } from '../../constants/categories';
import EmptyState from '../../../../components/common/EmptyState';

const ContentDisplay = ({
  contents,
  searchTerm,
  viewType,
  tabValue,
  onClearSearch,
  onCreateContent,
  loading,
  readingCategories = [],
  // Import tab constants with all five tabs
  tabConstants = { 
    draftTab: 0, 
    publishTab: 1, 
    approvedTab: 2, 
    releasedTab: 3, 
    archivedTab: 4 
  }
}) => {
  const { draftTab, publishTab, approvedTab, releasedTab, archivedTab } = tabConstants;

  // Determine tab type for display logic
  const getTabType = () => {
    switch (tabValue) {
      case publishTab:
        return 'published';
      case approvedTab:
        return 'approved';
      case releasedTab:
        return 'released';
      case archivedTab:
        return 'archived';
      case draftTab:
      default:
        return 'draft';
    }
  };

  const tabType = getTabType();
  const showEmptyState = !loading && contents.length === 0;

  // Dynamic empty state messaging based on tab type
  const getEmptyStateProps = () => {
    if (searchTerm) {
      return {
        title: "No matching content found",
        message: "Try adjusting your search or clear the filter",
        actionText: "Clear Search",
        onAction: onClearSearch
      };
    }

    switch (tabType) {
      case 'published':
        return {
          title: "No published content available yet",
          message: "Publish your draft content to see it listed here",
          actionText: "Create Content",
          onAction: onCreateContent
        };
      case 'approved':
        return {
          title: "No approved content available yet",
          message: "Content awaiting approval will appear here",
          actionText: "Create Content",
          onAction: onCreateContent
        };
      case 'released':
        return {
          title: "No released content available yet",
          message: "Release approved content to see it listed here",
          actionText: "Create Content",
          onAction: onCreateContent
        };
      case 'archived':
        return {
          title: "No archived content available",
          message: "Archived content will appear here",
          actionText: "Create Content",
          onAction: onCreateContent
        };
      case 'draft':
      default:
        return {
          title: "No content available yet",
          message: "Generate your first reading practice content by clicking the 'Create New Practice' button",
          actionText: "Create Content",
          onAction: onCreateContent
        };
    }
  };

  const emptyStateProps = getEmptyStateProps();

  return (
    <Box role="tabpanel" id={`tabpanel-${tabValue}`} aria-labelledby={`tab-${tabValue}`}>
      {showEmptyState ? (
        <EmptyState
          title={emptyStateProps.title}
          message={emptyStateProps.message}
          actionText={emptyStateProps.actionText}
          onAction={emptyStateProps.onAction}
        />
      ) : viewType === 'grid' ? (
        <Grid container spacing={3}>
          {contents.map((cover, index) => (
            <Grid 
              item 
              xs={12} 
              sm={6} 
              md={4} 
              key={cover.id || index}
              className="card-fade-in"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <ContentCard
                id={cover.id}
                gradeLevel={cover.gradeLevel}
                thumbnailImageURL={cover.thumbnailUrl}
                title={cover.title}
                category={readingCategories?.find(c => c.id === cover.categoryId)?.name || categories[cover.categoryId] || 'Unknown'}
                synopsis={cover.synopsis}
                onRefresh={() => { }}
                tabType={tabType}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ContentList
          contents={contents}
          onRefresh={() => { }}
          loading={loading}
          tabType={tabType}
        />
      )}
    </Box>
  );
};

export default ContentDisplay;